import dayjs from 'dayjs'

/**
 * 禁用当天以前日期
 * @param data
 * @returns {boolean}
 */
export function disabledDate(data) {
    return parseInt(dayjs(data).format('YYYYMMDD')) < parseInt(dayjs(Date.now()).format('YYYYMMDD'));
}

/**
 * 患者评估 处理trauma
 * @param value
 * @param type
 * @returns {*|undefined}
 */
export function handlerTrauma(value, type = 'submit') {
    const map = {0: true, 1: false};
    if (type === 'submit') return map[value] || undefined;
    else if (type === 'detail') {
        for (let key in map) {
            if (map[key] === value) return parseInt(key);
        }
        return undefined;
    }
}

/**
 * 患者评估-处理 provisionsMode
 * @param value
 * @param type
 * @returns {{provisionsModeSupplement: (*|undefined), provisionsMode: *}|{provisionsModeSupplement: undefined, provisionsMode: *}}
 */
export function handlerProvisionsMode(value, type = 'submit') {
    if (type === 'detail') {
        if (value.provisionsMode && value.provisionsModeSupplement) {
            return `${value.provisionsMode}:${value.provisionsModeSupplement}`
        }
        return value.provisionsMode
    }
    if (type === 'submit') {
        if (!value) return {};
        value = value.split(':');
        if (value.length === 1) {
            return {
                provisionsModeSupplement: undefined,
                provisionsMode: value[0]
            }
        } else {
            return {
                provisionsModeSupplement: value[1] || undefined,
                provisionsMode: value[0]
            }
        }
    }
}